import { EVENT_TYPES as STANDARD_EVENT_TYPES } from '@stepstone/events-js';
import { showModalThunk } from './modalSlice.js';
import { FORM_TYPES } from '../../../types/paramsConfig.js';
import { initCommonModalsDependencies } from './initCommonModalsDependencies.js';
const EVENT_TYPES = {
    ...STANDARD_EVENT_TYPES.CANDIDATE_PROFILE_EVENTS,
    INTERNAL_EVENTS: {
        SHOW_REGISTRATION_SUCCESS: 'INTERNAL_EVENTS_SHOW_REGISTRATION_SUCCESS',
        HIDE_REGISTRATION_SUCCESS: 'INTERNAL_EVENTS_HIDE_REGISTRATION_SUCCESS',
        SHOW_TWO_STEP_MODAL: 'INTERNAL_EVENTS_SHOW_TWO_STEP_MODAL',
        HIDE_TWO_STEP_MODAL: 'INTERNAL_EVENTS_HIDE_TWO_STEP_MODAL',
        SHOW_LINKEDIN_IMPORT_PROFILE_MODAL: 'SHOW_LINKEDIN_IMPORT_PROFILE_MODAL',
        HIDE_LINKEDIN_IMPORT_PROFILE_MODAL: 'HIDE_LINKEDIN_IMPORT_PROFILE_MODAL',
    },
};
export const getSubscriptionEvents = ({ showLoginModal, showRegistrationModal, showResetPasswordModal, showLinkedInImportProfileModal, hideModal, }) => [
    {
        eventName: EVENT_TYPES.SHOW_LOGIN_MODAL,
        updateFunction: showLoginModal,
    },
    {
        eventName: EVENT_TYPES.SHOW_REGISTRATION_MODAL,
        updateFunction: showRegistrationModal,
    },
    {
        eventName: EVENT_TYPES.HIDE_LOGIN_MODAL,
        updateFunction: hideModal,
    },
    {
        eventName: EVENT_TYPES.HIDE_REGISTRATION_MODAL,
        updateFunction: hideModal,
    },
    {
        eventName: EVENT_TYPES.SHOW_RESETPASSWORD_MODAL,
        updateFunction: showResetPasswordModal,
    },
    {
        eventName: EVENT_TYPES.HIDE_RESETPASSWORD_MODAL,
        updateFunction: hideModal,
    },
    {
        eventName: EVENT_TYPES.INTERNAL_EVENTS.HIDE_REGISTRATION_SUCCESS,
        updateFunction: hideModal,
    },
    {
        eventName: EVENT_TYPES.INTERNAL_EVENTS.HIDE_TWO_STEP_MODAL,
        updateFunction: hideModal,
    },
    {
        eventName: EVENT_TYPES.HIDE_FULLSCREEN_RLA_MODAL,
        updateFunction: hideModal,
    },
    {
        eventName: EVENT_TYPES.INTERNAL_EVENTS.SHOW_LINKEDIN_IMPORT_PROFILE_MODAL,
        updateFunction: showLinkedInImportProfileModal,
    },
    {
        eventName: EVENT_TYPES.INTERNAL_EVENTS.HIDE_LINKEDIN_IMPORT_PROFILE_MODAL,
        updateFunction: hideModal,
    },
];
export const getUpdateFunctionsCustomEvent = (encodedGTLibraryUrl, logoBrandName, dispatch) => ({
    showLoginModal: ({ detail }) => {
        initCommonModalsDependencies(encodedGTLibraryUrl, logoBrandName, dispatch, detail);
        dispatch(showModalThunk(FORM_TYPES.LOGIN));
    },
    showRegistrationModal: ({ detail, }) => {
        initCommonModalsDependencies(encodedGTLibraryUrl, logoBrandName, dispatch, detail);
        dispatch(showModalThunk(FORM_TYPES.REGISTRATION));
    },
    showResetPasswordModal: ({ detail, }) => {
        initCommonModalsDependencies(encodedGTLibraryUrl, logoBrandName, dispatch, detail);
        dispatch(showModalThunk(FORM_TYPES.RESET_PASSWORD));
    },
    showLinkedInImportProfileModal: ({ detail, }) => {
        initCommonModalsDependencies(encodedGTLibraryUrl, logoBrandName, dispatch, detail);
        dispatch(showModalThunk(FORM_TYPES.LINKEDIN_IMPORT_PROFILE));
    },
});
export const getUpdateFunctionsPubSub = (encodedGTLibraryUrl, logoBrandName, dispatch) => ({
    showLoginModal: (_, payload) => {
        initCommonModalsDependencies(encodedGTLibraryUrl, logoBrandName, dispatch, payload);
        dispatch(showModalThunk(FORM_TYPES.LOGIN));
    },
    showRegistrationModal: (_, payload) => {
        initCommonModalsDependencies(encodedGTLibraryUrl, logoBrandName, dispatch, payload);
        dispatch(showModalThunk(FORM_TYPES.REGISTRATION));
    },
    showResetPasswordModal: (_, payload) => {
        initCommonModalsDependencies(encodedGTLibraryUrl, logoBrandName, dispatch, payload);
        dispatch(showModalThunk(FORM_TYPES.RESET_PASSWORD));
    },
    showLinkedInImportProfileModal: (_, payload) => {
        initCommonModalsDependencies(encodedGTLibraryUrl, logoBrandName, dispatch, payload);
        dispatch(showModalThunk(FORM_TYPES.LINKEDIN_IMPORT_PROFILE));
    },
});
//# sourceMappingURL=eventsSubscriptions.js.map